<template>
  <base-dialog :showDialog="showDialog" :scrollable="true">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          <div class="d-flex justify-center">
            <span>
              Log de Sincronização
            </span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-timeline dark dense align-top>
            <v-timeline-item
              v-for="(sync, index) in synchronizationLog"
              :key="index"
              :color="`${sync.sucesso ? 'transparent' : 'transparent'}`"
              class="text-caption white--text"
            >
              <template v-slot:icon>
                <v-icon v-if="sync.sucesso" color="success"
                  >mdi-check-bold</v-icon
                >
                <v-icon v-else color="error">mdi-close-thick</v-icon>
              </template>
              <div class="d-flex flex-column elevation-12 rounded-xl pa-5">
                <div>
                  <span>{{ sync.sucesso ? 'Sucesso' : 'Falhou' }}</span>
                </div>
                <div>
                  <v-icon left small>mdi-calendar</v-icon>
                  <span>{{ sync.data }}</span>
                </div>
                <div>
                  <v-icon left small>mdi-clock-outline</v-icon>
                  <span>{{ sync.hora }}</span>
                </div>
                <div class="mt-1">
                  <v-expansion-panels accordion flat hover>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        color="transparent"
                        :ripple="true"
                        :class="
                          `${
                            sync.sucesso ? 'success' : 'error'
                          }--text text--lighten-4 rounded-b-xl`
                        "
                      >
                        <span>Detalhar Processo</span>
                        <template v-slot:actions>
                          <v-icon
                            :color="
                              `${sync.sucesso ? 'success' : 'error'} lighten-4`
                            "
                            >mdi-arrow-down</v-icon
                          >
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="d-flex flex-column">
                          <div
                            v-for="(mensagem, indexMsg) in sync.mensagens"
                            :key="indexMsg"
                            class="d-flex flex-column justify-start pa-1"
                          >
                            <div
                              :class="
                                `${
                                  mensagem.mensagem
                                    ? 'green--text text--lighten-4'
                                    : 'red--text text--lighten-3'
                                }`
                              "
                            >
                              <v-icon small class="mr-1"
                                >mdi-clock-outline</v-icon
                              >{{ mensagem.hora }}
                            </div>
                            <v-spacer />
                            <div
                              :class="
                                `${
                                  mensagem.mensagem
                                    ? 'green--text text--lighten-4'
                                    : 'red--text text--lighten-3'
                                }`
                              "
                            >
                              <v-icon small class="mr-1">{{
                                mensagem.mensagem
                                  ? 'mdi-progress-check'
                                  : 'mdi-progress-close'
                              }}</v-icon
                              >{{
                                mensagem.mensagem
                                  ? mensagem.mensagem
                                  : mensagem.erro
                              }}
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item
              v-if="synchronizationLog.length <= 0"
              color="transparent"
              class="text-caption white--text"
              style="user-select: none"
            >
              <template v-slot:icon>
                <v-icon color="yellow lighten-4" x-large
                  >mdi-help-circle-outline</v-icon
                >
              </template>
              <div class="d-flex flex-column elevation-12 rounded-xl pa-5">
                <div>
                  <span class="text-h6 yellow--text text--lighten-4"
                    >Não encontramos nenhum Log de Sincronização.</span
                  >
                </div>
                <div class="text-subtitle-1">
                  <span
                    >Entre em contato com nosso suporte para verificarmos os
                    problemas que podem ter causado isso.</span
                  >
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-card-actions>
          <v-btn color="info" small :loading="loading" @click="$emit('goBack')">
            <v-icon small left>mdi-exit-to-app</v-icon>
            <span class="text-overline d-none d-sm-flex">{{
              $t('labels.voltar')
            }}</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            small
            :loading="loading"
            @click="refreshLogs({ page: 1 })"
          >
            <v-icon small left>mdi-refresh</v-icon>
            <span class="text-overline d-none d-sm-flex">atualizar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
export default {
  components: {
    BaseDialog: () => import('@/components/shared/base-dialog/BaseDialog'),
  },
  data: () => {
    return {
      loading: false,
    }
  },
  methods: {
    async refreshLogs(payload) {
      try {
        this.loading = true
        await this.getLogs(payload)
      } catch (error) {
        this.$toasted.error(`Erro ao consultar Log de Sincronização (${error})`)
        this.setEmptyLog([])
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.refreshLogs({ page: 1 })
  },
  props: {
    synchronizationLog: {
      type: Array,
      required: true,
    },
    getLogs: {
      type: Function,
      required: true,
    },
    setEmptyLog: {
      type: Function,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
}
</script>

<style></style>
